import { render, staticRenderFns } from "./SFInput.vue?vue&type=template&id=29a6cce4&lang=pug&"
import script from "./SFInput.vue?vue&type=script&lang=ts&"
export * from "./SFInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports